import { useCurrentUser } from 'shared/hooks';

import { useUserAvailableCommunityProducts } from './useUserAvailableCommunityProducts';

/**
 * React hook to fetch the current user's available community products for the selected community.
 *
 * Uses React Query to asynchronously retrieve community product data from the marketplace API.
 * The query is enabled only if the current user is available.
 *
 * @returns The query result containing the current user's available community products.
 */
export function useCurrentUserAvailableCommunityProducts() {
  const { user: currentUser } = useCurrentUser();

  return useUserAvailableCommunityProducts(currentUser);
}
